import * as React from "react";
import { Button, Card, Input } from "antd";
import { resolve } from "inversify-react";
const { TextArea } = Input;

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { HttpService } from 'src/core/services/http.service';
import { ZuluIcon } from "src/app/shared/icon";

interface ISqlCommandProps {
	sql: string;
	request: boolean;
}

export default class SqlCommand extends React.PureComponent<{}, ISqlCommandProps> {
	state = {
		sql: "",
		request: false,
	};

	@resolve
	private toast: ToastNotifications;

	@resolve
	private httpService: HttpService;

	public render() {
		const { request, sql } = this.state;

		return (
			<div className="window window-normal">
				<div />
				<Card
					title="Run Sql commands"
					extra={<ZuluIcon type="database" />}
					style={{ width: '100%' }}>
					<TextArea
						rows={10}
						onChange={this.handleChange}
						value={sql}
						disabled={request}
					/>
					<Button disabled={sql === "" || request} type="primary" onClick={this.handleClick}>Run</Button>
				</Card>
			</div>
		);
	}

	private handleChange = (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
		this.setState({
			sql: ev.target.value,
		});
	}

	private handleClick = async () => {
		this.setState({
			request: true,
		});
		try {
			const result = await this.httpService.post("/api/v1/sql-command", { sql: this.state.sql });
			this.toast.showToast("Sql command success!", `${result.data} element(s) affected`, "success");
		} catch (e) {
			this.toast.showToast("Sql command failed!", ObjectUtils.parseError(e), "error");
		} finally {
			this.setState({
				request: false,
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/home/sql-command.tsx